import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", null, [
      _createElementVNode("path", {
        d: "M14.44,5.56a2.78,2.78,0,1,0-2.78-2.78A2.77,2.77,0,0,0,14.44,5.56Z",
        fill: "currentColor"
      }),
      _createElementVNode("path", {
        d: "M20.52,3.34a1.38,1.38,0,0,0-1.47,1.3S18.85,7,17.22,7.31a9.58,9.58,0,0,1-3.94-.62A11.15,11.15,0,0,0,8,6,5.31,5.31,0,0,0,3.8,10.2a1.38,1.38,0,0,0,1.14,1.6l.23,0a1.38,1.38,0,0,0,1.37-1.16,2.56,2.56,0,0,1,2-1.91,6.18,6.18,0,0,1,2.6.26L9.51,13.19a1.21,1.21,0,0,0,0,.14l-.81,2.94c-.36,1.78-1,2.11-3.66,2.84L3.2,19.6a1.39,1.39,0,0,0,.37,2.73,1.12,1.12,0,0,0,.36,0l1.79-.49c2.54-.69,4.93-1.34,5.63-4.88l.24-.86a6.44,6.44,0,0,1,1.23,6.12,1.39,1.39,0,0,0,.88,1.76,1.35,1.35,0,0,0,.44.07,1.4,1.4,0,0,0,1.32-.95,9,9,0,0,0-2.94-9.9l1.36-3.41a8.6,8.6,0,0,0,3.94.29c2.94-.65,3.9-3.58,4-5.21A1.39,1.39,0,0,0,20.52,3.34Z",
        fill: "currentColor"
      })
    ], -1)
  ])))
}
export default { render: render }